import { useState } from "react";
import { supabase } from "@/integrations/supabase/client";
import { toast } from "sonner";

export interface RatingData {
  restaurantId: string;
  tableNumber: string;
  orderId?: string;
  foodQuality?: number;
  serviceQuality?: number;
  environment?: number;
  valueForMoney?: number;
  overallExperience?: number;
  comments?: string;
  customerName?: string;
  customerEmail?: string;
  customerPhone?: string;
  acceptMarketing?: boolean;
}

export function useCustomerRating() {
  const [isSubmitting, setIsSubmitting] = useState(false);

  const submitRating = async (data: RatingData): Promise<boolean> => {
    setIsSubmitting(true);

    try {
      const { data: result, error } = await supabase.rpc("submit_customer_rating", {
        p_restaurant_id: data.restaurantId,
        p_table_number: data.tableNumber,
        p_order_id: data.orderId || null,
        p_food_quality: data.foodQuality || null,
        p_service_quality: data.serviceQuality || null,
        p_environment: data.environment || null,
        p_value_for_money: data.valueForMoney || null,
        p_overall_experience: data.overallExperience || null,
        p_comments: data.comments || null,
        p_customer_name: data.customerName || null,
        p_customer_email: data.customerEmail || null,
        p_customer_phone: data.customerPhone || null,
        p_accept_marketing: data.acceptMarketing || false,
      });

      if (error) throw error;

      toast.success("Obrigado pela sua avaliação!");
      return true;
    } catch (err) {
      console.error("Erro ao enviar avaliação:", err);
      toast.error("Erro ao enviar avaliação");
      return false;
    } finally {
      setIsSubmitting(false);
    }
  };

  return {
    submitRating,
    isSubmitting,
  };
}
